import updateUserProfile from 'Gql/users/mutations/updateUserProfile.graphql';

import AreasExpertiseExperience from 'Models/UserProfile/AreasExpertiseExperience';
import ManualAreasExpertiseExperience from 'Models/UserProfile/ManualAreasExpertiseExperience';
import DrivingLicenseAvailability from 'Models/UserProfile/DrivingLicenseAvailability';
import DrivingLicenseState from 'Models/UserProfile/DrivingLicenseState';
import DrivingLicenseExpDate from 'Models/UserProfile/DrivingLicenseExpDate';
import DrivingLicensePhotoUrl from 'Models/UserProfile/DrivingLicensePhotoUrl';
import CommercialDrivingLicenseAvailability from 'Models/UserProfile/CommercialDrivingLicenseAvailability';
import ValidHazmatEndorsementAvailability from 'Models/UserProfile/ValidHazmatEndorsementAvailability';
import VehicleAvailability from 'Models/UserProfile/VehicleAvailability';
import AutoInsuranceAvailability from 'Models/UserProfile/AutoInsuranceAvailability';
import AutoInsuranceName from 'Models/UserProfile/AutoInsuranceName';
import AutoInsuranceExpDate from 'Models/UserProfile/AutoInsuranceExpDate';
import AutoInsurancePhotoUrl from 'Models/UserProfile/AutoInsurancePhotoUrl';
import PECCardsAvailability from 'Models/UserProfile/PECCardsAvailability';
import HealthIssuesAvailability from 'Models/UserProfile/HealthIssuesAvailability';
import EmergencyContact from 'Models/UserProfile/EmergencyContact';
import LongDriveAvailability from 'Models/UserProfile/LongDriveAvailability';
import ConfirmInfoToDate from 'Models/UserProfile/ConfirmInfoToDate';
import AgreeToUpdate from 'Models/UserProfile/AgreeToUpdate';
import AgreeFollowPolicies from 'Models/UserProfile/AgreeFollowPolicies';
import AgreeBackgroundCheck from 'Models/UserProfile/AgreeBackgroundCheck';
import UserSignature from 'Models/UserProfile/UserSignature';
import UserPhoto from 'Models/UserProfile/UserPhoto';
import FinalStep from 'Models/UserProfile/FinalStep';
import { Utils } from 'vue-graphql-models';

const privVue = new WeakMap();

class UserProfile {
  sections = [];

  /**
   * Class constructor
   *
   * @param vue
   * @param sectionParams
   */
  constructor(vue, sectionParams) {
    privVue.set(this, vue);
    const spKeys = sectionParams ? Object.keys(sectionParams) : [];
    this.modules.forEach((module) => {
      const foundSection = spKeys.find(p => Utils.ucwords(p) === module.className);
      let params = {};
      // istanbul ignore else
      if (foundSection) {
        params = sectionParams[foundSection] || {};
      }
      this.sections.push(Utils.spawn(module, [this, params]));
    });
  }

  /**
   * Hidden getter which returns profile modules to instantiate
   *
   * @returns {Array.<_BaseUserProfile>}
   */
  // eslint-disable-next-line class-methods-use-this
  get modules() {
    return [
      AreasExpertiseExperience,
      ManualAreasExpertiseExperience,
      DrivingLicenseAvailability,
      DrivingLicenseState,
      DrivingLicenseExpDate,
      DrivingLicensePhotoUrl,
      CommercialDrivingLicenseAvailability,
      ValidHazmatEndorsementAvailability,
      VehicleAvailability,
      AutoInsuranceAvailability,
      AutoInsuranceName,
      AutoInsuranceExpDate,
      AutoInsurancePhotoUrl,
      PECCardsAvailability,
      HealthIssuesAvailability,
      EmergencyContact,
      LongDriveAvailability,
      ConfirmInfoToDate,
      AgreeToUpdate,
      AgreeFollowPolicies,
      AgreeBackgroundCheck,
      UserSignature,
      UserPhoto,
      FinalStep,
    ];
  }

  /**
   * Hidden getter which returns last section
   * @return {number}
   */
  get lastSection() {
    return this.sections.findIndex(s => (s.value === null || s.class === 'FinalStep'));
  }

  // eslint-disable-next-line class-methods-use-this
  isComplete() {
    // TODO filter optional steps is wrong
    // return this.sections.filter(s => (s.value !== null || s.class === 'FinalStep'))
    //   .length === this.sections.length;
    return true;
  }

  save() {
    this.vue.$nextTick(() => {
      const data = this.getSectionValues();
      this.vue.$apollo.mutate({
        mutation: updateUserProfile,
        variables: {
          data,
        },
      });
    });
  }

  getSectionValues() {
    const values = {};
    this.sections.forEach((s) => {
      // istanbul ignore else
      if (s.value === null) {
        return;
      }

      values[Utils.lowerCaseFirst(s.class)] = {
        value: s.value,
      };

      // istanbul ignore else
      if (s.additionalFormValue) {
        values[Utils.lowerCaseFirst(s.class)].additionalFormValue = s.additionalFormValue;
      }
    });
    // We need cloneDeep here to clear it out from Vue observers
    return Utils.cloneDeep(values);
  }

  get vue() {
    return privVue.get(this);
  }
}

export default UserProfile;
